import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';

import * as HydrationActions from './hydration.actions';
import { AppStateInterface } from 'src/app/appState.interface';

@Injectable()
export class HydrationEffects implements OnInitEffects {
  hydrate$ = createEffect(() =>
    this.action$.pipe(
      ofType(HydrationActions.hydrate),
      map(() => {
        const storageValue = localStorage.getItem('state');
        //const dashboardsValue = localStorage.getItem("actia_dashboards");
        if (storageValue) {
          try {
            let state = JSON.parse(storageValue);
            /* let dashboards, dashboardData;
            if (dashboardsValue) {
              ({ dashboards, dashboardData } = JSON.parse(dashboardsValue));
            } */
            // Merge dashboard state stored into the main state
            state = {
              ...state
              //dashboards: dashboards ?? {},
              //dashboardData: dashboardData ?? {}
            };
            return HydrationActions.hydrateSuccess({ state });
          } catch {
            localStorage.removeItem('state');
            //localStorage.removeItem("actia_dashboards");
          }
        }
        return HydrationActions.hydrateFailure();
      })
    )
  );

  serialize$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(
          HydrationActions.hydrateSuccess,
          HydrationActions.hydrateFailure
        ),
        switchMap(() => this.store),
        distinctUntilChanged(),
        tap((state) => {
          // Ottimizzazione: riduciamo i dati degli assets mantenendo solo i campi essenziali
          const optimizeAssets = (assets: any) => {
            if (!assets || !assets.selected) return assets;
            return {
              ...assets,
              selected: assets.selected.map((asset: any) => ({
                uid: asset.uid,
                isChild: asset.isChild,
                subscribed: asset.subscribed,
                disabled: asset.disabled,
                haveCommunicated: asset.haveCommunicated,
                dataHidden: asset.dataHidden
              }))
            };
          };

          // SESTO GRUPPO: Rimuoviamo anche setSelectedAssets
          const stateAny = state as any;
          const {
            getCustomers,
            getVehiclesOfCustomers,
            getTrailersOfCustomers,
            getFleetsOfCustomers,
            getDriversOfCustomers,
            getTeamsOfCustomers,
            user,
            setTabFilterRef,
            setTabAssetChooserRef,
            setSelectedPeriod,
            applySelectedPeriod,
            completeApplyState,
            filterRefSetting,
            setSelectedAssets,
            dashboardData,
            dashboards,
            applySelectedAssets,
            iotAssets,
            vehicleFilters,
            ...stateOptimized
          } = stateAny;

          // Ottimizziamo gli assets prima di salvare
          const optimizedState = {
            ...stateOptimized,
            // applySelectedAssets: optimizeAssets(
            //   stateOptimized.applySelectedAssets
            // ),
            //setSelectedAssets: optimizeAssets(stateOptimized.setSelectedAssets),
            completeApplyState: completeApplyState
              ? {
                  ...completeApplyState,
                  applySelectedAssets: optimizeAssets(
                    completeApplyState.applySelectedAssets
                  )
                }
              : undefined
          };

          // // Rimuoviamo completeApplyState se non necessario
          // if (!optimizedState.completeApplyState) {
          //   delete optimizedState.completeApplyState;
          // }

          localStorage.setItem('state', JSON.stringify(optimizedState));
          // Estrai solo signalsCatalog da dashboardData per salvarlo
          const signalsCatalogToSave = dashboardData?.signalsCatalog || null;

          localStorage.setItem("state", JSON.stringify({
            ...stateOptimized,
            dashboardData: {
              signalsCatalog: signalsCatalogToSave
            }
          }));
        })
      ),
    { dispatch: false }
  );

  constructor(
    private action$: Actions,
    private store: Store<AppStateInterface>
  ) {}

  ngrxOnInitEffects(): Action {
    return HydrationActions.hydrate();
  }
}
